<template>

  <a target="_blank" :href="item.pdf">
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="2"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="3"></pdf>
  </a>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Statement',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "https://www.asspm.fr/rubriques/reglement-2019.pdf"
        }
      }
    }
  }

</script>